import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "item" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "cookies" }
const _hoisted_11 = { class: "cookies" }
const _hoisted_12 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_geschuetzter_router_link = _resolveComponent("geschuetzter-router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("h1", null, "PHV", -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, { to: "/phv" }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("Direkt")
            ])),
            _: 1,
            __: [12]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/phv')
          }, {
            default: _withCtx(() => [
              _createTextVNode("Makler " + _toDisplayString(_ctx.vermittlernummerHinweistext), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerLinkUrl('phv')
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("Makler-Link")
            ])),
            _: 1,
            __: [13]
          }, 8, ["to"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[17] || (_cache[17] = _createElementVNode("h1", null, "PHV 2020", -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, { to: "/phv2020" }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode("Direkt")
            ])),
            _: 1,
            __: [15]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/phv2020')
          }, {
            default: _withCtx(() => [
              _createTextVNode("Makler " + _toDisplayString(_ctx.vermittlernummerHinweistext), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerLinkUrl('phv2020')
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode("Makler-Link")
            ])),
            _: 1,
            __: [16]
          }, 8, ["to"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[20] || (_cache[20] = _createElementVNode("h1", null, "VGV", -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, { to: "/vgv" }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [
              _createTextVNode("Direkt")
            ])),
            _: 1,
            __: [18]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/vgv')
          }, {
            default: _withCtx(() => [
              _createTextVNode("Makler " + _toDisplayString(_ctx.vermittlernummerHinweistext), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerLinkUrl('vgv')
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode("Makler-Link")
            ])),
            _: 1,
            __: [19]
          }, 8, ["to"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[23] || (_cache[23] = _createElementVNode("h1", null, "VHV", -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, { to: "/vhv" }, {
            default: _withCtx(() => _cache[21] || (_cache[21] = [
              _createTextVNode("Direkt")
            ])),
            _: 1,
            __: [21]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/vhv')
          }, {
            default: _withCtx(() => [
              _createTextVNode("Makler " + _toDisplayString(_ctx.vermittlernummerHinweistext), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerLinkUrl('vhv')
          }, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createTextVNode("Makler-Link")
            ])),
            _: 1,
            __: [22]
          }, 8, ["to"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[26] || (_cache[26] = _createElementVNode("h1", null, "BL", -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, { to: "/bl" }, {
            default: _withCtx(() => _cache[24] || (_cache[24] = [
              _createTextVNode("Direkt")
            ])),
            _: 1,
            __: [24]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/bl')
          }, {
            default: _withCtx(() => [
              _createTextVNode("Makler " + _toDisplayString(_ctx.vermittlernummerHinweistext), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerLinkUrl('bl')
          }, {
            default: _withCtx(() => _cache[25] || (_cache[25] = [
              _createTextVNode("Makler-Link")
            ])),
            _: 1,
            __: [25]
          }, 8, ["to"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[29] || (_cache[29] = _createElementVNode("h1", null, "BH", -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, { to: "/bh" }, {
            default: _withCtx(() => _cache[27] || (_cache[27] = [
              _createTextVNode("Direkt")
            ])),
            _: 1,
            __: [27]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/bh')
          }, {
            default: _withCtx(() => [
              _createTextVNode("Makler " + _toDisplayString(_ctx.vermittlernummerHinweistext), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerLinkUrl('bh')
          }, {
            default: _withCtx(() => _cache[28] || (_cache[28] = [
              _createTextVNode("Makler-Link")
            ])),
            _: 1,
            __: [28]
          }, 8, ["to"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[32] || (_cache[32] = _createElementVNode("h1", null, "HG", -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, { to: "/hg" }, {
            default: _withCtx(() => _cache[30] || (_cache[30] = [
              _createTextVNode("Direkt")
            ])),
            _: 1,
            __: [30]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/hg')
          }, {
            default: _withCtx(() => [
              _createTextVNode("Makler " + _toDisplayString(_ctx.vermittlernummerHinweistext), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerLinkUrl('hg')
          }, {
            default: _withCtx(() => _cache[31] || (_cache[31] = [
              _createTextVNode("Makler-Link")
            ])),
            _: 1,
            __: [31]
          }, 8, ["to"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[35] || (_cache[35] = _createElementVNode("h1", null, "FH", -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, { to: "/fh" }, {
            default: _withCtx(() => _cache[33] || (_cache[33] = [
              _createTextVNode("Direkt")
            ])),
            _: 1,
            __: [33]
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/fh')
          }, {
            default: _withCtx(() => [
              _createTextVNode("Makler " + _toDisplayString(_ctx.vermittlernummerHinweistext), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_geschuetzter_router_link, {
            to: _ctx.maklerLinkUrl('fh')
          }, {
            default: _withCtx(() => _cache[34] || (_cache[34] = [
              _createTextVNode("Makler-Link")
            ])),
            _: 1,
            __: [34]
          }, 8, ["to"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[53] || (_cache[53] = _createElementVNode("h1", null, "Cookies", -1)),
      _createElementVNode("form", {
        novalidate: "",
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setzeCookies && _ctx.setzeCookies(...args)), ["prevent"]))
      }, [
        _createElementVNode("p", null, [
          _cache[36] || (_cache[36] = _createElementVNode("label", { for: "channel" }, "GEV Channel", -1)),
          _cache[37] || (_cache[37] = _createTextVNode("  ")),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "channel",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.channel) = $event))
          }, null, 512), [
            [_vModelText, _ctx.channel]
          ])
        ]),
        _createElementVNode("p", null, [
          _cache[38] || (_cache[38] = _createElementVNode("label", { for: "campagne" }, "GEV Campagne", -1)),
          _cache[39] || (_cache[39] = _createTextVNode("  ")),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "campagne",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.campagne) = $event))
          }, null, 512), [
            [_vModelText, _ctx.campagne]
          ])
        ]),
        _createElementVNode("p", null, [
          _cache[40] || (_cache[40] = _createElementVNode("label", { for: "vid" }, "Vid", -1)),
          _cache[41] || (_cache[41] = _createTextVNode("  ")),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "vid",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vid) = $event))
          }, null, 512), [
            [_vModelText, _ctx.vid]
          ])
        ]),
        _createElementVNode("p", null, [
          _cache[42] || (_cache[42] = _createElementVNode("label", { for: "gev_prtn" }, "GEV Prtn", -1)),
          _cache[43] || (_cache[43] = _createTextVNode("  ")),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "gev_prtn",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.gev_prtn) = $event))
          }, null, 512), [
            [_vModelText, _ctx.gev_prtn]
          ])
        ]),
        _createElementVNode("p", null, [
          _cache[44] || (_cache[44] = _createElementVNode("label", { for: "gev_prms" }, "GEV Prms", -1)),
          _cache[45] || (_cache[45] = _createTextVNode("  ")),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "gev_prms",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.gev_prms) = $event))
          }, null, 512), [
            [_vModelText, _ctx.gev_prms]
          ])
        ]),
        _createElementVNode("p", null, [
          _cache[46] || (_cache[46] = _createElementVNode("label", { for: "gev_ref" }, "GEV Ref", -1)),
          _cache[47] || (_cache[47] = _createTextVNode("  ")),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "gev_ref",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.gev_ref) = $event))
          }, null, 512), [
            [_vModelText, _ctx.gev_ref]
          ])
        ]),
        _createElementVNode("p", null, [
          _cache[48] || (_cache[48] = _createElementVNode("label", { for: "gev_lp" }, "GEV Lp", -1)),
          _cache[49] || (_cache[49] = _createTextVNode("  ")),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "gev_lp",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.gev_lp) = $event))
          }, null, 512), [
            [_vModelText, _ctx.gev_lp]
          ])
        ]),
        _createElementVNode("p", null, [
          _cache[50] || (_cache[50] = _createElementVNode("label", { for: "s_id" }, "FinanceAds s_id", -1)),
          _cache[51] || (_cache[51] = _createTextVNode("  ")),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "s_id",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.s_id) = $event))
          }, null, 512), [
            [_vModelText, _ctx.s_id]
          ])
        ]),
        _cache[52] || (_cache[52] = _createElementVNode("button", { type: "submit" }, "Cookies setzen", -1))
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _cache[60] || (_cache[60] = _createElementVNode("h1", null, "Makler", -1)),
      _cache[61] || (_cache[61] = _createElementVNode("h2", null, "Makler-Portal", -1)),
      _createElementVNode("p", null, [
        _cache[55] || (_cache[55] = _createElementVNode("label", { for: "vermittlernummerSelect" }, "Vermittlernummer ", -1)),
        _withDirectives(_createElementVNode("select", {
          id: "vermittlernummerSelect",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ausgewaehlteVermittlernummer) = $event))
        }, [
          _cache[54] || (_cache[54] = _createElementVNode("option", {
            selected: "selected",
            value: ""
          }, "Vermittlernummer", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vermittlernummern, (option, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: option
            }, _toDisplayString(option), 9, _hoisted_12))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.ausgewaehlteVermittlernummer]
        ])
      ]),
      _cache[62] || (_cache[62] = _createElementVNode("h2", null, "Makler-Link", -1)),
      _createElementVNode("p", null, [
        _cache[56] || (_cache[56] = _createElementVNode("label", { for: "vermittlerId" }, "Vermittler-Id", -1)),
        _cache[57] || (_cache[57] = _createTextVNode("  ")),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "vermittlerId",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.vermittlerId) = $event))
        }, null, 512), [
          [_vModelText, _ctx.vermittlerId]
        ])
      ]),
      _createElementVNode("p", null, [
        _cache[58] || (_cache[58] = _createElementVNode("label", { for: "externeReferenz" }, "Externe Referenz", -1)),
        _cache[59] || (_cache[59] = _createTextVNode("  ")),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "externeReferenz",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.externeReferenz) = $event))
        }, null, 512), [
          [_vModelText, _ctx.externeReferenz]
        ])
      ])
    ])
  ]))
}